module.exports = __webpack_public_path__ + "media/images/about-us-page-150dc14517e8ef4decd037e1bf456a57.jpg";